import {Component, input} from '@angular/core'
import {DecimalPipe} from '@angular/common'

@Component({
  selector: 'spb-value',
  imports: [
    DecimalPipe
  ],
  templateUrl: './value.component.html',
  styleUrl: './value.component.scss'
})
export class ValueComponent {
  public value = input.required<string | number>()
  public percent = input.required<number>()
  public readonly hidePercent = input.required<boolean>()
}
